export default "__VITE_ASSET__7fb4d2a2__"